import './style.scss';

import BeerImage from 'images/beer.jpg';
import WineImage from 'images/wine.jpg';
import SpiritsImage from 'images/spirits.jpg';
import MoreImage from 'images/more.jpg';

import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Spinner from 'react-spinkit';
import _ from 'lodash';
import BrandPageHeadTags from './head';
import { loadBrand } from './actions';
import { addCart, showCart } from 'components/cart/actions';
import { trackNow } from 'shared/models/analytic';
import { trackInfo } from 'shared/models/product';
import TextOverImage from 'components/ui/textOverImage';
import ProductImage from 'components/ui/productImage';

let BrandPage = class BrandPage extends React.Component {
  constructor(props) {
    super(props);
    this.add = this.add.bind(this);
  }

  componentDidMount() {
    const prevBrandname = this.props.brandname;
    const nextBrandname = this._brandNameFromRoute(this.props);
    if (nextBrandname !== prevBrandname) {
      this.props.loadBrand(nextBrandname);
    }
  }

  componentWillReceiveProps(nextProps) {
    const prevBrandname = this._brandNameFromRoute(this.props);
    const nextBrandname = this._brandNameFromRoute(nextProps);
    if (nextBrandname !== prevBrandname) {
      this.props.loadBrand(nextBrandname);
    }
  }

  _brandNameFromRoute(props) {
    const params = (props.match && props.match.params) || {};
    return params.brandname;
  }

  add(product) {
    this.props.addCart(product, 1, { checkout: this.props.checkout });
    setTimeout(this.props.showCart, 500);
  }

  render() {
    const brandname = _.startCase(this.props.brandname);

    return this.props.loading ? (
      <div className="row center-xs brand-page__loading-container banner-padding">
        <div className="col-xs-12">
          <Spinner spinnerName="three-bounce" />
        </div>
      </div>
    ) : (
      <div className="brand-page banner-padding">
        <BrandPageHeadTags brandname={brandname} slug={this.props.brandname} />
        <Header content={this.props.header} brandname={brandname} />
        <div className="brand-page__container">
          <div className="row center-xs">
            {this.props.products.map(product => (
              <div key={product.sku_id} className="col-xs-6 col-sm-3">
                <Product product={product} add={() => this.add(product)} />
              </div>
            ))}
          </div>
        </div>
        <Footer content={this.props.footer} />
      </div>
    );
  }
};

BrandPage = connect(state => ({ ...state.brands }), {
  loadBrand,
  addCart,
  showCart
})(BrandPage);

function Header(props) {
  return props.content ? (
    <div dangerouslySetInnerHTML={{ __html: props.content }} />
  ) : (
    <div className="brand-page__header">
      <div className="brand-page__heading-label">Shop</div>
      <h1 className="brand-page__heading">{props.brandname}</h1>
      <hr className="light" />
    </div>
  );
}

function Footer(props) {
  return props.content ? (
    <div dangerouslySetInnerHTML={{ __html: props.content }} />
  ) : (
    <div className="brand-page__footer">
      <div className="brand-page__divider divider-group">
        <div className="divider-group__divider" />
        <div className="divider-group__text">Shop By Category</div>
        <div className="divider-group__divider" />
      </div>
      <div className="row">
        <div className="col-xs-6 col-md-3">
          <TextOverImage href="/beer" text="Beer" image={BeerImage} />
        </div>
        <div className="col-xs-6 col-md-3">
          <TextOverImage href="/wine" text="Wine" image={WineImage} />
        </div>
        <div className="col-xs-6 col-md-3">
          <TextOverImage href="/spirits" text="Spirits" image={SpiritsImage} />
        </div>
        <div className="col-xs-6 col-md-3">
          <TextOverImage href="/more" text="More" image={MoreImage} />
        </div>
      </div>
    </div>
  );
}

function Product(props) {
  const {
    title,
    subtitle,
    volume,
    price,
    regularPriceDisplay,
    priceDisplay,
    description
  } = props.product;
  let url = props.product.url || '';
  if (url[0] !== '/') url = '/' + url;

  return (
    <div className="brand-page__product">
      <div className="brand-page__product-image">
        <Link
          to={url}
          onClick={() => trackNow('Product Clicked', trackInfo(props))}
        >
          <ProductImage product={props.product} alt={title} />
        </Link>

        {!!price && (
          <button
            className="btn-primary green brand-page__add-btn"
            onClick={e => {
              e.stopPropagation();
              return props.add();
            }}
          >
            Add
          </button>
        )}
      </div>
      <Link
        to={url}
        onClick={() => trackNow('Product Clicked', trackInfo(props))}
      >
        <div className="brand-page__product-details">
          <div>{title}</div>
          <div>{subtitle}</div>
          <div>
            <span>{volume}</span>
            {!!price && (
              <span>
                {' '}
                |
                {regularPriceDisplay &&
                  regularPriceDisplay !== priceDisplay && (
                    <span className="text-light strikethrough">
                      {' '}
                      ${regularPriceDisplay}
                    </span>
                  )}
                <span> ${priceDisplay}</span>
              </span>
            )}
          </div>
        </div>
      </Link>
      <p className="brand-page__product-description">{description}</p>
    </div>
  );
}

export default BrandPage;
export { Product };



// WEBPACK FOOTER //
// ./shared/components/brands/brand.js